import { render, staticRenderFns } from "./Census.vue?vue&type=template&id=a79915f8"
import script from "./Census.vue?vue&type=script&lang=js"
export * from "./Census.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a79915f8')) {
      api.createRecord('a79915f8', component.options)
    } else {
      api.reload('a79915f8', component.options)
    }
    module.hot.accept("./Census.vue?vue&type=template&id=a79915f8", function () {
      api.rerender('a79915f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/Census.vue"
export default component.exports